module.exports = __webpack_public_path__ + "static/media/yunying.343bb1e1.png";